module.exports = __webpack_public_path__ + "media/images/svg/instagram-91767c4a181ff2b31332e312a085c99e.svg";